import { render, staticRenderFns } from "./ModalEx.vue?vue&type=template&id=4c8e91ee&scoped=true&"
import script from "./ModalEx.vue?vue&type=script&lang=js&"
export * from "./ModalEx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e91ee",
  null
  
)

export default component.exports